import React from 'react';
import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';

function CustomUpdateStatusModel({
	updateStatusModel,
	setUpdateStatusModel,
	handleUpdateStatus,
	type = 'status',
	statusText,
	title,
}) {
	return (
		<Modal
			className="deleteVendorsModal"
			title={title ?? (type === 'delete' ? 'Delete Invoice' : 'Confirm Update Status')}
			isOpen={updateStatusModel}
			onClose={() => {
				setUpdateStatusModel(false);
			}}
			cancelButton={() => {
				setUpdateStatusModel(false);
			}}
		>
			<p
				style={{
					textAlign: 'center',
					backgroundColor: '#E6F5FF',
					padding: '10px',
					borderRadius: '5px',
					fontWeight: '600',
					color: 'black',
				}}
			>
				{/* Are you sure you want to change update PO status of Purchase Order? */}
				{statusText}
			</p>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					justifyContent: 'end',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-gray add-pro"
					button="Cancel"
					onClick={() => {
						setUpdateStatusModel(false);
					}}
				/>

				<Button
					type="button"
					button="Confirm"
					className="mt-0 px-4 btn-danger relative"
					onClick={handleUpdateStatus}
				/>
			</div>
		</Modal>
	);
}

export default CustomUpdateStatusModel;
